export const GETSIZE_SUCCESS = "GETSIZE_SUCCESS";
export const GETSIZE_ERROR = "GETSIZE_ERROR";

export const ADDSIZE_SUCCESS = "ADDSIZE_SUCCESS";
export const ADDSIZE_ERROR = "ADDSIZE_ERROR";

export const UPDATESIZE_SUCCESS = "UPDATESIZE_SUCCESS";
export const UPDATESIZE_ERROR = "UPDATESIZE_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";


